/**
 * @module mapbs.components.realestateinformation.desktop.realestateinformationdesktop
 */
import angular from 'angular';

import './../realestateinformationpanel.scss';

import olInteractionDraw from 'ol/interaction/Draw.js';
import olLayerVector from 'ol/layer/Vector.js';
import olSourceVector from 'ol/source/Vector';
import olCollection from 'ol/Collection.js';
import olStyleStyle from 'ol/style/Style.js';
import olFeature from 'ol/Feature.js';
import olStyleFill from 'ol/style/Fill.js';
import olStyleText from 'ol/style/Text.js';
import olStyleStroke from 'ol/style/Stroke.js';
import {buffer} from 'ol/extent';

import ngeoFeatureOverlayMgr from 'ngeo/map/FeatureOverlayMgr';
import ngeoMiscToolActivate from 'ngeo/misc/ToolActivate.js';
import ngeoLocation from 'ngeo/statemanager/Location.js';


import mapbsRealEstateSelectionService from 'mapbs/components/reportpanel/service/realestateselection';
import mapbsLiegtypselectObject from 'mapbs/components/reportpanel/liegtypselect/liegtypselectobject.js';
import mapbsRealestateinformationpanel from 'mapbs/components/realestateinformation/panel/realestateinformationpanel';
import mapbsLiegtypselect from 'mapbs/components/reportpanel/liegtypselect/liegtypselect';


const moduleRealestateinformationdesktop = angular.module('mapbsRealestateinformationdesktopModule', [
    mapbsRealEstateSelectionService.name,
    mapbsRealestateinformationpanel.name,
    mapbsLiegtypselect.name,
    ngeoLocation.name,
]);

moduleRealestateinformationdesktop.run(
    /* ngInject */($templateCache) => {
        $templateCache.put('mapbs/realestateinformationdesktop', require('./realestateinformationdesktop.html'));
    }
);

/** @type {!angular.Component} */
const RealestateinformationdesktopComponent = {
    controller: 'mapbsRealestateinformationdesktopController as ctrl',
    templateUrl: 'mapbs/realestateinformationdesktop',
    bindings: {
        'map': '<mapbsMap',
        'realestatedesktopActive': '<mapbsActive',
        'mapbsQuerygridActive': '=mapbsQuerygridActive',
        'gmfUser': '=mapbsGmfuser'
    },
};

moduleRealestateinformationdesktop.component('mapbsRealestateinformationdesktop', RealestateinformationdesktopComponent);

class RealestateinformationdesktopController {
    /**
   * @constructor
   * @param {angular.Scope} $scope
   * @param {angular.$http} $http
   * @param {angular.$injector} $injector
   * @param {angular.$window} $window the window
   * @param {ngeo.statemanager.Location} ngeoLocation ngeo Location service.
   * @param {ngeo.ToolActivateMgr} ngeoToolActivateMgr
   * @param {mapbs.RealEstateSelectionService} mapbsRealEstateSelectionService
   * @ngInject
   */
    constructor($scope, $http, $injector, $window, ngeoLocation, ngeoToolActivateMgr, mapbsRealEstateSelectionService) {
        /**
         * @param {angular.Scope}
         * @private
         */
        this.scope = $scope;

        this.http = $http;

        /**
         * @type {!ngeo.statemanager.Location}
         * @private
         */
        this.ngeoLocation_ = ngeoLocation;

        this.map = null;

        this.realEstateContent = {};

        this.$window = $window;

        this.realEstateSelectionService = mapbsRealEstateSelectionService;

        /** @type {Array} */
        this.liegtypselection = [];

        /** @type {string} */
        this.state = 'inactive';

        /** @type {string} */
        this.egrid = '';

        this.gmfUser = null;

        /** @type {boolean} */
        this.mapbsQuerygridActive = false;

        /** @type {boolean} */
        this.realestatedesktopActive = false;

        /**
         * @type {olLayerVector}
        */
        this.layer = null;
        this.selectedFeatures = new olCollection();

        /** @type {string} @private */
        this.baseurl = $injector.get('ngeoEgtBase');

        this.showEgtModal = false;
        this.rendercaptcha = false;
        this.egtinfotext = '';
        this.checkaccess();


        /**
         * @type {ngeo.map.FeatureOverlayMgr}
         * @private
        */
        this.featureOverlayLayer_ = ngeoFeatureOverlayMgr.getLayer();

        this.ngeoMiscToolActivate = ngeoToolActivateMgr;
        this.tool = new ngeoMiscToolActivate(this, 'grundstueckinfoTool');

        // store default tool: select query in order to activate or deactivate it
        this.defaultMapTool = this.ngeoMiscToolActivate.groups_.mapTools.find(x => x.defaultTool).tool;

        this.ngeoMiscToolActivate.registerTool(
            'mapTools',
            this.tool,
            false
        );

        this.drawinteraction = new olInteractionDraw({
            type: /** @type{import('ol/geom/GeometryType.js')} */ ('Point'),
        });

        this.drawinteraction.on('drawend', (event) => {
            this.coord = event.feature.getGeometry();
            this.realEstateSelectionService
                .getFeatureByCoord(this.coord)
                .then((response) => {
                    this.handleQueryFeatureResult(response);
                });
            this.setState('wait');
        });

        /** @type {boolean} */
        this.mapInteractionActive = false;

        this.coord = [];

        /**
         * @type {import('ol/source/Vector').default<*>}
         * @private
         */
        this.vectorSource_ = new olSourceVector({
            wrapX: false,
        });


        this.scope.$watch(
            () => {
                return this.realestatedesktopActive;
            },
            (newVal) => {
                if (!newVal) {
                    this.setState('inactive');
                    if (this.layer) {
                        this.layer.getSource().clear(true);
                    }
                }
            }
        );

        this.scope.$watch(
            () => {
                return this.map;
            },
            (newVal) => {
                if (newVal) {
                    this.oninit();
                }
            }
        );

        this.scope.$watch(
            () => {
                return this.gmfUser;
            },
            (newVal) => {
                if (newVal.username) {
                    if (this.ngeoLocation_.hasParam('init_realestate_id') || this.ngeoLocation_.hasParam('grundstuecksinfo')){

                        const realestateValue = this.ngeoLocation_.getParam('init_realestate_id');

                        // direct call with existing EGRID
                        if (realestateValue){
                            this.egrid = realestateValue;
                            this.initWithEgrid();
                            this.setState('inactive');
                            if(this.realEstateContent.geometry) {
                                this.removeParams();
                            }
                        }
                        // no direct url call
                        else {
                            this.setState('active');
                        }
                    }
                }
            }
        );

        this.scope.$watch(
            () => {
                return this.mapInteractionActive;
            },
            (newVal) => {
                if (newVal) {
                    this.map.addInteraction(this.drawinteraction);
                } else {
                    this.map.removeInteraction(this.drawinteraction);
                }
            }
        );

        this.scope.$watch(
            () => {
                return this.realEstateContent;
            },
            (newVal) => {
                // Check access to Eigentumsauskunft
                this.checkaccess();
                if (newVal) {
                    // Load Geometry
                    if(newVal !== undefined ) {
                        this.initWithEgrid();
                    }
                }
            }
        );
    }

    initWithEgrid() {

        if (this.layer) {
            this.layer.getSource().clear(true);
        }
        if (this.realEstateContent.geometry) {
            this.updateLiegenschaft(this.realEstateContent.geometry.values_);

            // Zoom to Feature when inital EGRID exists
            const layerExtent = this.layer.getSource().getExtent();
            const layerExtentBuffer = buffer(layerExtent, 20);
            this.map.getView().fit(layerExtentBuffer, this.map.getSize());
            if (this.realEstateContent.geometry && this.gmfUser.username) {
                this.removeParams();
            }
        }
    }

    oninit() {

        this.layer = new olLayerVector({
            source: new olSourceVector({
                features: this.selectedFeatures,
            }),
            style: (feature) => {
                if (feature.get('type') === 'building') {
                    return new olStyleStyle({
                        fill: new olStyleFill({ color: [255, 255, 255, 0] }),
                        stroke: new olStyleStroke({ color: [32, 32, 32, 1], width: 2 }),
                        text: new olStyleText({
                            font: 'bold 14px Calibri, sans-serif',
                            fill: new olStyleFill({ color: '#000' }),
                            stroke: new olStyleStroke({color: '#fff', width: 2}),
                            text: feature.get('name'),
                            overflow: true
                        })
                    });
                }
                else {
                    return new olStyleStyle({
                        fill: new olStyleFill({ color: [255, 255, 255, 0.6] }),
                        stroke: new olStyleStroke({ color: [204, 51, 51, 1], width: 2 })
                    });
                }
            },
        });
        this.layer.setMap(this.map);
    }

    /**
       * @private
       */
    setState(state) {
        switch (state) {
            case 'active':
                this.ngeoMiscToolActivate.activateTool(this.tool);
                // deactivate select tool of map
                if (this.mapbsQuerygridActive) {
                    this.mapbsQuerygridActive = false;
                }
                this.ngeoMiscToolActivate.deactivateTool(this.defaultMapTool);
                this.mapInteractionActive = true;
                this.removeParams();
                break;
            case 'inactive':
                this.ngeoMiscToolActivate.deactivateTool(this.tool);
                // activate select tool of map
                this.ngeoMiscToolActivate.activateTool(this.defaultMapTool);
                this.mapInteractionActive = false;
                break;
            case 'wait':
                // do not yet set mapInteractionActive to false;
                break;
            case 'error':
                //  enable user to click;
                this.mapInteractionActive = true;
                break;
            default:
                this.mapInteractionActive = false;
                break;
        }
        this.state = state;
    }

    /**
    * @private
    */
    handleQueryFeatureResult(features) {
        if (features.length === 0) {
            this.errormessage = 'Keine Daten gefunden';
            this.setState('error');
        } else if (features.length === 1) {
            this.getRealestateInformation(features[0].get('bs_egrid'));
        } else {
            this.openliegtypselect(features);
        }
    }

    /**
    * prepares data for liegtypselector if more than 1 feature was returned by the feature request
    * @private
    */
    openliegtypselect(featurelist) {
        this.liegtypselection = [];
        featurelist.forEach((f) => {
            const lgto = new mapbsLiegtypselectObject();
            lgto.typ = f.get('bs_art');
            lgto.sektion = f.get('bs_sektionnummer');
            lgto.parznr = f.get('bs_prznummer');
            lgto.egrid = f.get('bs_egrid');
            lgto.geom = f.get('the_geom');
            this.liegtypselection.push(lgto);
        });

        this.showmodal = true;
    }

    /**
    * handle selection of a liegenschaft from liegtypselector
    */
    selectliegtyp(lgt) {
        this.getRealestateInformation(lgt.egrid);
    }

    closeliegtyp() {
        this.setState('inactive');
    }

    updateLiegenschaft(coordinates) {
        this.layer.getSource().clear(true);
        const feature = new olFeature(coordinates);
        this.selectedFeatures.push(feature);
    }

    /**
  * @param {string} egrid
  * @returns {angular.$q.Promise<any>}
  */

    getRealestateInformation(egrid, geom) {
        this.updateLiegenschaft(geom);
        this.egrid = egrid;
        this.setState('inactive');
    }

    /**  @private  */
    checkaccess() {

        this.http
        .get(`${this.baseurl}eigentumsauskunftngeo/sektion=0&parznr=0`, {
            withCredentials: true,
        })
        .then((response) => {
            this.egtinfotext = response.data['info'];

            if (response.data['zugriff'] === 1) {
                this.rendercaptcha = false;
            }
            if (response.data['intranet'] === 0) {
                // this.rendercaptcha = true;
                this.rendercaptcha = true;
            } else {
                this.rendercaptcha = false;
            }
        })
        .catch((ex) => {
            if (ex.status === 403) {
                this.egtinfotext = 'Die Eigentumsauskunft ist in Ihrem Land nicht verfügbar.';
            } else {
                this.egtinfotext = 'Die Eigentumsauskunft ist momentan nicht verfügbar.';
            }

        });
    }

    removeParams() {
        if (this.ngeoLocation_.hasParam('init_realestate_id') && this.gmfUser.username){
            this.ngeoLocation_.deleteParam('init_realestate_id');
        }
        if (this.ngeoLocation_.hasParam('grundstuecksinfo') && this.gmfUser.username){
            this.ngeoLocation_.deleteParam('grundstuecksinfo');
        }
    }

}
moduleRealestateinformationdesktop.controller('mapbsRealestateinformationdesktopController', RealestateinformationdesktopController);

export default moduleRealestateinformationdesktop;
